import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {requestCustomFieldChoices} from "../../../redux/Actions/customFields.actions";
import {
  getCustomFieldChoicesList,
  getCustomFieldChoicesTotalCount,
  getCustomFieldChoicesPaginationUrls,
} from "../../../redux/Selectors/customFields.selector";

export const useCustomFieldChoicesTableData = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const customFieldChoicesList = useSelector(getCustomFieldChoicesList);
  const customFieldChoicesTotalCount = useSelector(getCustomFieldChoicesTotalCount);
  const customFieldChoicesUrls = useSelector(getCustomFieldChoicesPaginationUrls);

  useEffect(() => {
    dispatch(requestCustomFieldChoices());
  }, [dispatch]);

  const handlePageChange = (page) => {
    const url =
      currentPage < page
        ? customFieldChoicesUrls?.nextUrl
        : customFieldChoicesUrls?.prevUrl;
    dispatch(requestCustomFieldChoices(url));
    setCurrentPage(page);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  return {paginationConfig, customFieldChoicesList, customFieldChoicesTotalCount};
};
